
import { AuthModule } from '@/store/modules/AuthModule'
import { NotifyModule } from '@/store/modules/NotifyModule'
import { ToastModule } from '@/store/modules/ToastModule'
import VehicleService from '../../../../../services/vehicle-service'
import RepositoryService from '../../../../../services/repository-service'
import VehicleListService from '../../../../../services/vehicle-list-service'
import VehicleModal from '@/views/vehicle/components/VehicleModal.vue'
import {
  Component,
  Vue
} from 'vue-property-decorator'
import Draggable from 'vuedraggable'

@Component({
  name: 'Vehicle',
  components: {
    Draggable,
    VehicleModal
  }
})
export default class Vehicle extends Vue {
  protected isTableBusy = false
  protected isDrag = false
  protected isVehiclesUpdated = false
  protected vehicleList: any = []
  protected vehicles: any = []
  protected companies: any = []
  protected company: any = {}

  created () {
    this.boot()
  }

  public boot () {
    this.populateVehicles()
    this.populateCompanyNames()
    this.addVehicle()
  }

  protected showMasterData (id) {
    (this.$refs.VehicleModal as any).showModal(id)
  }

  protected editVehicle (vehicle) {
    this.showMasterData(vehicle.vehicle_id)
  }

  public async setVehicle (tableIndex: number, vehicle: any) {
    if (Object.keys(this.company).length === 0) {
      NotifyModule.set('Please select a company first.. ')
      this.vehicleList[tableIndex].vehicle = {}
      this.vehicleList[tableIndex].type = null
      this.vehicleList[tableIndex].wheels = null
      this.vehicleList[tableIndex].capacity = null
      return false
    }

    const exists = this.vehicleList.some((v, i) => i !== tableIndex && v.vehicle_id === vehicle.vehicle_id)
    if (exists) {
      NotifyModule.set('Vehicle already added. Please select another.. ')
      this.vehicleList[tableIndex].vehicle = {}
      this.vehicleList[tableIndex].type = null
      this.vehicleList[tableIndex].wheels = null
      this.vehicleList[tableIndex].capacity = null
      return false
    }

    this.vehicleList[tableIndex].vehicle_id = vehicle.vehicle_id
    this.vehicleList[tableIndex].vehicle_number = vehicle.vehicle_number
    this.vehicleList[tableIndex].type = vehicle.type
    this.vehicleList[tableIndex].wheels = vehicle.wheels
    this.vehicleList[tableIndex].capacity = vehicle.capacity
  }

  protected deleteVehicle (tableIndex: number, vehicle: any) {
    if (vehicle.id === null) {
      this.vehicleList.splice(tableIndex, 1)
    } else {
      if (confirm(`Are you sure you want to delete this Vehicle ${vehicle.vehicle_number}?`) === true) {
        VehicleListService.deleteVehicle(vehicle.id).then((response) => {
          ToastModule.message(response.data.message)
          this.vehicleList.splice(tableIndex, 1)
        }).catch(error => {
          ToastModule.message(error.response.data.message)
        })
      }
    }
  }

  protected save () {
    const list: any = []
    this.vehicleList.forEach((vehicle, index) => {
      list.push({
        id: vehicle.id,
        line_number: index + 1,
        company_id: vehicle.company_id ?? this.company.id,
        vehicle_id: vehicle.vehicle_id,
        created_user: vehicle.created_user ?? AuthModule.user.fullname,
        modified_user: AuthModule.user.fullname
      })
    })
    VehicleListService.saveVehicles(list).then((response) => {
      ToastModule.message(response.data.message)
      this.populateVehicleList()
      this.isVehiclesUpdated = false
    }).catch(error => {
      ToastModule.message(error.response.data.message)
    })
  }

  protected addVehicle () {
    this.vehicleList.push({
      id: null,
      vehicle: {},
      vehicle_id: null,
      vehicle_number: null,
      type: null,
      wheels: null,
      capacity: null,
      created_user: AuthModule.user.fullname,
      modified_user: AuthModule.user.fullname
    })
  }

  protected async populateVehicleList () {
    this.isTableBusy = true
    this.vehicleList = []
    const response = await VehicleListService.getVehicles(this.company.id)
    if (response.data.length === 0 && this.vehicleList.length === 0) {
      this.addVehicle()
    } else {
      this.vehicleList = response.data.map(vehicle => {
        /* ...vehicle,
        vehicle: {
          vehicle_id: vehicle.vehicle_id,
          vehicle_number: vehicle.vehicle_number,
          type: vehicle.type,
          wheels: vehicle.wheels,
          capacity: Number(vehicle.capacity)
        } */
        const match = this.vehicles.find(v => v.value.vehicle_id === vehicle.vehicle_id)
        return {
          ...vehicle,
          vehicle: match || {}
        }
      })
    }
    this.isTableBusy = false
    this.isVehiclesUpdated = false
  }

  private async populateCompanyNames () {
    const response = await RepositoryService.getCompanies()
    response.data.forEach((element) => {
      this.companies.push({
        value: {
          id: element.id,
          name: element.name
        },
        text: element.name
      })
    })
  }

  protected async populateVehicles () {
    this.vehicles = []
    this.vehicleList = []
    const response = await VehicleService.getVehicles()
    response.data.forEach((element) => {
      this.vehicles.push({
        value: {
          vehicle_id: element.id,
          vehicle_number: element.vehicle_number,
          type: element.type,
          wheels: element.wheels,
          capacity: element.capacity
        },
        text: element.vehicle_number
      })
    })

    if (this.isVehiclesUpdated && Object.keys(this.company).length !== 0) this.populateVehicleList()
  }
}
